import React from 'react';

export interface AvatarProps {
  src?: string;
  alt?: string;
  children?: React.ReactNode;
  size?: number;
  className?: string;
  sx?: any; // For MUI compatibility during migration
  onError?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = '',
  children,
  size,
  className = '',
  sx,
  onError,
}) => {
  // Extract size from sx if provided (MUI compatibility)
  const width = sx?.width || sx?.w || size || 40;
  const height = sx?.height || sx?.h || size || 40;

  const sizeStyle = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  const borderStyle = sx?.border ? { border: sx.border } : {};

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full bg-hover-bg text-white overflow-hidden ${className}`}
      style={{ ...sizeStyle, ...borderStyle }}
    >
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover" onError={onError} />
      ) : (
        <span className="text-sm font-medium">{children}</span>
      )}
    </div>
  );
};

export default Avatar;
